<template>
  <div
    class="main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      { 'expanded': !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered) },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">

          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link
              class="navbar-brand"
              :to="$route.meta.service === 'root'
                ? '/root/dashboard'
                : $route.meta.service === 'franchise'
                  ? '/franchise/dashboard'
                  : $route.meta.service === 'company'
                    ?'/company/dashboard':$route.meta.service === 'e-commerce'
                      ?'/e-commerce/dashboard':''"
            >
              <span class="brand-logo">
                <b-img
                  v-if="navbarImage"
                  :src="navbarImage"
                  alt="logo"
                />
                <b-img
                  v-else
                  :src="require('@/assets/images/logo/startapp-logo.png')"
                  alt="logo"
                />
              </span>
              <h2 class="brand-text">
                {{ navbarTitle }}
              </h2>
            </b-link>
          </li>

          <!-- Toggler Button -->
          <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              />
              <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed"
              />
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div
      :class="{'d-block': shallShadowBottom}"
      class="shadow-bottom"
    />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="evt => { shallShadowBottom = evt.srcElement.scrollTop > 0 }"
    >
      <vertical-nav-menu-items
        v-if="menuService!==''"
        :items="itemsMenuService"
        class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>

import navMenuStoreGroceryItems from '@/navigation/store-grocery'
import navMenuStoreFoodItems from '@/navigation/store-food'
import navMenuStoreQueueItems from '@/navigation/store-queue'
import navMenuDriverDeliveryItems from '@/navigation/driver-delivery'
import navMenuDriverCallItems from '@/navigation/driver-call'
import navMenuServicesItems from '@/navigation/services'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BLink, BImg } from 'bootstrap-vue'
import { provide, computed, ref } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import store from '@/store'
import VerticalNavMenuItems from './components/vertical-nav-menu-items/VerticalNavMenuItems.vue'
import useVerticalNavMenu from './useVerticalNavMenu'

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  computed: {
    navbarTitle() {
      return store.state.appConfig.navbarTitle
    },
    navbarImage() {
      return store.state.appConfig.navbarImage
    },
    menuService() {
      return store.state.appConfig.menuService
    },
    itemsMenuService() {
      // eslint-disable-next-line no-nested-ternary
      return this.menuService !== ''
      // eslint-disable-next-line no-nested-ternary
        ? this.menuService === 'store-grocery' ? navMenuStoreGroceryItems
        // eslint-disable-next-line no-nested-ternary
          : this.menuService === 'store-food' ? navMenuStoreFoodItems
          // eslint-disable-next-line no-nested-ternary
            : this.menuService === 'store-queue' ? navMenuStoreQueueItems
              // eslint-disable-next-line no-nested-ternary
              : this.menuService === 'driver-delivery' ? navMenuDriverDeliveryItems
                // eslint-disable-next-line no-nested-ternary
                : this.menuService === 'driver-call' ? navMenuDriverCallItems
                // eslint-disable-next-line no-nested-ternary
                  : this.menuService === 'services' ? navMenuServicesItems
                  // eslint-disable-next-line no-nested-ternary
                    : navMenuServicesItems : []
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props)

    const { skin } = useAppConfig()

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false)

    provide('isMouseHovered', isMouseHovered)

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    const collapseTogglerIconFeather = computed(() => (collapseTogglerIcon.value === 'unpinned' ? 'CircleIcon' : 'DiscIcon'))

    return {
      navMenuStoreGroceryItems,
      navMenuStoreFoodItems,
      navMenuStoreQueueItems,
      navMenuDriverDeliveryItems,
      navMenuDriverCallItems,
      navMenuServicesItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // Menu Service
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
